import Vue from 'vue'
import VueRouter from 'vue-router'
import store from './store'

import Login from '@/views/Login.vue'
import { zirafHTTP, bus, setAuthHeader } from './main'
import GlobalMixins from './mixins'
const Portal = () => import('@/views/Portal.vue')
const Users = () => import('@/views/Users.vue')
const User = () => import('@/views/User.vue')
const NewUser = () => import('@/views/NewUser.vue')
const Clients = () => import('@/views/Clients.vue')
const Client = () => import('@/views/Client.vue')
const NewClient = () => import('@/views/NewClient.vue')
const PageNotFound = () => import('@/views/PageNotFound.vue')

const globalMixins = new GlobalMixins()

Vue.use(VueRouter)

const routes = [
	{
		path: '/',
		name: 'login',
		component: Login,
		meta: {
			title: 'Login'
		}
	},
	{
		path: '',
		component: Portal,
		children: [
			{
				path: 'kandidaten',
				name: 'users',
				component: Users,
				meta: {
					protected: true,
					title: 'Kandidaten'
				}
			},
			{
				path: 'kandidaat/:id',
				name: 'user',
				component: User,
				meta: {
					protected: true,
					title: 'Kandidaat'
				}
			},
			{
				path: 'nieuwe-kandidaat',
				name: 'new-user',
				component: NewUser,
				meta: {
					protected: true,
					title: 'Nieuwe kandidaat'
				}
			},
			{
				path: 'klanten',
				name: 'clients',
				component: Clients,
				meta: {
					protected: true,
					title: 'Klanten'
				}
			},
			{
				path: 'klant/:id',
				name: 'client',
				component: Client,
				meta: {
					protected: true,
					title: 'Klant'
				}
			},
			{
				path: 'nieuwe-klant',
				name: 'new-client',
				component: NewClient,
				meta: {
					protected: true,
					title: 'Nieuwe klant'
				}
			},
		]
	},
	{
		path: '/pagina-niet-gevonden',
		alias: '*',
		name: 'pageNotFound',
		component: PageNotFound,
		meta: {
			title: 'Oeps!'
		}
	}
]

const router = new VueRouter({
	mode: 'history',
	base: process.env.BASE_URL,
	routes
})

router.beforeEach((to, from, next) => {
	if ('scrollRestoration' in history) {
		history.scrollRestoration = 'manual';
	}
	
	if (store.getters.preventNavigation.prevent) {
		if (confirm(store.getters.preventNavigation.message ? store.getters.preventNavigation.message : 'Weet je zeker dat je door wilt gaan?')) {
			store.dispatch('setPreventNavigation', {prevent: false})
		} else {
			bus.$emit('preventedNavigation')
		
			next(false)
			return
		}
	}

	bus.$emit('routeChange')

	if (to.meta.title) {
		document.title = `${process.env.VUE_APP_TITLE} | ${to.meta.title}`
	} else {
		document.title = process.env.VUE_APP_TITLE
	}

	if (to.meta.protected) {
		Vue.nextTick(() => {
			if (window.localStorage.getItem('accessToken')) {
				zirafHTTP.get('auth/check-token')
					.then(response => {
						if (response.data.succes) next()
					})
					.catch(error => {
						console.error(error.response.data)
	
						window.localStorage.removeItem('accessToken')
	
						store.dispatch('setLoginError', globalMixins.returnErrorByCode(error.response.data.errorCode))
						
						next({ name: 'login' })
					})
			} else {
				store.dispatch('setLoginError', 'Voor deze pagina moet je eerst inloggen')
				
				next({ name: 'login' })
			}
		})
	}

	next()
})

export default router
